/* Team-Set-Karten: Modellauswahl tauscht Bild und Ziel-Link */
(function () {
  function karteVerdrahten(karte) {
    var wahl = karte.querySelector('.hs-set-select');
    var bild = karte.querySelector('.hs-set-bild');
    var cta = karte.querySelector('.hs-set-cta');
    if (!wahl || !cta) return;

    var basis = cta.getAttribute('data-basis') || cta.getAttribute('href') || '';

    wahl.addEventListener('change', function () {
      var opt = wahl.options[wahl.selectedIndex];
      if (!opt) return;

      var variante = opt.getAttribute('data-variante');
      cta.setAttribute('href', variante ? basis + '?variant=' + variante : basis);

      var quelle = opt.getAttribute('data-bild');
      if (!bild || !quelle) return;

      var vorlader = new Image();
      vorlader.onload = function () {
        bild.src = quelle;
        bild.alt = opt.getAttribute('data-alt') || '';
        bild.style.opacity = '1';
      };
      vorlader.onerror = function () {
        bild.style.opacity = '1';
      };
      bild.style.opacity = '0';
      vorlader.src = quelle;
    });
  }

  function start() {
    var karten = document.querySelectorAll('.hs-set');
    for (var i = 0; i < karten.length; i++) karteVerdrahten(karten[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
